module.exports = __webpack_public_path__ + "img/pleqqie-logo.11bb0508.svg";